import { render, staticRenderFns } from "./TaskNode.vue?vue&type=template&id=655ace57&scoped=true"
import script from "./TaskNode.vue?vue&type=script&lang=js"
export * from "./TaskNode.vue?vue&type=script&lang=js"
import style0 from "./TaskNode.vue?vue&type=style&index=0&id=655ace57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ace57",
  null
  
)

export default component.exports